/***
 * Used for excluding nav items from common navigation, cause of using in other places
 ***/
export const EXCLUDED_FROM_COMMON_NAVIGATION_IDS = ['church', 'church-users', 'analytics']
